import React from 'react';
import MDEditor from '@uiw/react-md-editor';

interface RichTextEditorProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  disabled?: boolean;
  className?: string;
  height?: string;
}

export const RichTextEditor: React.FC<RichTextEditorProps> = ({
  value,
  onChange,
  placeholder = '',
  disabled = false,
  className = '',
  height = '200px',
}) => {
  return (
    <div className={`rich-text-editor ${className}`} data-color-mode="light">
      <MDEditor
        value={value}
        onChange={(val) => onChange(val || '')}
        hideToolbar={false}
        visibleDragbar={false}
        height={height}
        data-color-mode="light"
        preview="edit"
        style={{
          backgroundColor: '#ffffff',
        }}
      />
    </div>
  );
};

export default RichTextEditor;
